import { render, staticRenderFns } from "./BracketsRoundsScheduleButton.vue?vue&type=template&id=950584f4"
import script from "./BracketsRoundsScheduleButton.vue?vue&type=script&lang=js"
export * from "./BracketsRoundsScheduleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports